<button class="border border-gray-600 rounded bg-gray-600 text-white px-2 py-1" (click)="toggle()">
    <fa-icon icon="bars"></fa-icon>
</button>
